import { render, staticRenderFns } from "./ui-property-type-select.vue?vue&type=template&id=d35a4a7e&"
import script from "./ui-property-type-select.vue?vue&type=script&lang=js&"
export * from "./ui-property-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports